import { render, staticRenderFns } from "./SmsComplianceBlockedDialog.vue?vue&type=template&id=f0e6c03c&scoped=true&lang=pug"
import script from "./SmsComplianceBlockedDialog.vue?vue&type=script&lang=js"
export * from "./SmsComplianceBlockedDialog.vue?vue&type=script&lang=js"
import style0 from "./SmsComplianceBlockedDialog.vue?vue&type=style&index=0&id=f0e6c03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e6c03c",
  null
  
)

export default component.exports